import { StaticMessageType } from '../../botTypes';

export const COMMON_ERR_MSG = _TL_('Sorry, something went wrong. Please try again.');
const COMMON_ERR = {
  showReferences: false,
  showStartOverBtn: true,
  showFeedback: true,
  msg: [COMMON_ERR_MSG],
};

export interface IStaticMessageDisplayConfig {
  showReferences: boolean;
  showStartOverBtn: boolean;
  showFeedback: boolean;
  msg: string[];
}

export const DEFAULT_DISPLAY_CONFIG: Record<StaticMessageType, IStaticMessageDisplayConfig | undefined> = {
  ResponsibleAI: {
    showReferences: false,
    showStartOverBtn: false,
    showFeedback: false,
    msg: [
      _TL_('Sorry, I\'m not able to help with that.  I can answer questions about Microsoft Advertising, such as:'),
      _TL_('{{pointPlaceholder}}How do I get ad campaigns up and running?'),
      _TL_('{{pointPlaceholder}}How can I get my ads in front of customers? '),
      _TL_('{{pointPlaceholder}}What are my billing options?'),
    ],
  },
  OutofScope: {
    showReferences: false,
    showStartOverBtn: false,
    showFeedback: true,
    msg: [
      _TL_('Sorry, I\'m not able to help with that.  I can answer questions about Microsoft Advertising, such as:'),
      _TL_('{{pointPlaceholder}}How do I get ad campaigns up and running?'),
      _TL_('{{pointPlaceholder}}How can I get my ads in front of customers? '),
      _TL_('{{pointPlaceholder}}What are my billing options?'),
      _TL_('\n'),
      _TL_('Please feel free to ask Microsoft Bing Chat (<a target="_blank" href="https://bing.com">Bing.com</a>) any other questions you may have.'),
    ],
  },
  Welcome: {
    showReferences: false,
    showStartOverBtn: false,
    showFeedback: false,
    msg: [
      _TL_('Hello, how can I help you today?'),

    ],
  },
  TokenExpiredAutoReload: {
    showReferences: false,
    showStartOverBtn: false,
    showFeedback: false,
    msg: [_TL_('Hi, welcome back! Your previous session expired due to inactivity but we have started a new session for you.')],
  },
  ConnectToAgent: {
    showReferences: false,
    showStartOverBtn: false,
    showFeedback: false,
    msg: ['PLACEHOLDER_FOR_CONNECT_TO_AGENT'],
  },
  SignInError: {
    showReferences: false,
    showStartOverBtn: false,
    showFeedback: true,
    msg: [_TL_('Sign in error')],
  },
  InternalError: COMMON_ERR,
  LargePayload: COMMON_ERR,
  MissingArgumentsInPayload: COMMON_ERR,
  StreamingCancelled: COMMON_ERR,
  EmptyReplyToIdToCancelStreaming: COMMON_ERR,
  NoDataAvailable: COMMON_ERR,
  StreamingCompleted: COMMON_ERR,
  TurnLimitReached: {
    showReferences: false,
    showStartOverBtn: true,
    showFeedback: true,
    msg: [_TL_('Chat limit reached. Start a new chat to continue. Chat history will be lost after resuming, so copy and save important information.')],
  },
  TokenExpired: {
    showReferences: false,
    showStartOverBtn: true,
    showFeedback: true,
    msg: [_TL_('The conversation is expired. Start a new chat to continue. Chat history will be lost after resuming, so copy and save important information.')],
  },
  ConversationExpired: {
    showReferences: false,
    showStartOverBtn: true,
    showFeedback: true,
    msg: [_TL_('The conversation is expired. Start a new chat to continue. Chat history will be lost after resuming, so copy and save important information.')],
  },
  Timeout: {
    showReferences: false,
    showStartOverBtn: false,
    showFeedback: true,
    msg: [COMMON_ERR_MSG],
  },
  HandoffMessage: {
    showReferences: false,
    showStartOverBtn: false,
    showFeedback: false,
    msg: [_TL_('Would you like to chat with a Microsoft Advertising Expert? Please describe your issue or question first.')],
  },
  ConversationResume: {
    showReferences: false,
    showStartOverBtn: false,
    showFeedback: false,
    msg: [_TL_('Welcome back to Copilot! How can I help?')],
  },
  InvalidPayload: COMMON_ERR,
  SydneyResponsibleAI: {
    showReferences: false,
    showStartOverBtn: true,
    showFeedback: false,
    msg: [_TL_('Sorry, I\'m not able to help with that. Please initiate a new conversation.')],
  },
};
